import { ScheduleTime } from "./configuration";

export enum StylistType {
  NoUser = 0,
  NoPreference = -1,
}


export interface FetchStylistOptions {
  salonId: number;
  stylistId?: number;
  bookingId?: number;
  accessToken?: string;
  date?: string;
  time?: string;
}


export interface FetchDatesOptions {
  salonId: number;
  bookingId?: number;
  accessToken?: string;
}


export interface FetchTimesOptions {
  salonId?: number;
  selectedTime?: string;
  selectedDate?: string;
  minHours?: number,
  bookingId?: number;
  accessToken?: string;
  canBookAnyTime?: boolean;
  schedule?: ScheduleTime;
  duration?: number;
}


export class Stylist {
  id: number = 0;
  name: string = '';
  image: string = '';
  expertise?: boolean;
  percentage?: number;
  isDefault: boolean = false;
  canBook: boolean = false;
  isOff: boolean = false;
  availableServices: any[] = [];

  constructor(fields) {
    Object.assign(this, fields);
  }
}

export function createStylist(blob, selectedServices = []): Stylist {
  const availableServices = selectedServices.filter((service: any) => {
    return (blob.services || []).find(blobService => blobService.service_id === service.id);
  });

  return new Stylist({
    id: Number(blob.stylist_id),
    name: blob.stylist_name,
    image: blob.full_profile_image,
    expertise: !!blob.expertise,
    percentage: Number(blob.rating_percent),
    isDefault: false,
    canBook: !!blob.enable_online_booking,
    isOff: blob.off_today !== undefined ? !!blob.off_today : false,
    availableServices,
  });
}

export function createDefaultStylist(availableServices = []): Stylist {
  return new Stylist({
    id: StylistType.NoPreference,
    name: 'No Preference',
    expertise: true,
    percentage: 0,
    isDefault: true,
    canBook: true,
    isOff: false,
    availableServices,
  });
}
